import { ResearchType } from '@empathy/global/data';

import { IResearchTemplate } from './research-template.interface';

import { ProjectAiInterviewContent } from '../ai-interview/project-ai-interview-content.model';

export class AIInterviewTemplate implements IResearchTemplate {
  id: string;
  activeInd: boolean;
  allowAnonymousInd: boolean;
  allowMultipleInd: boolean;
  category: number;
  targetCompletes: number;
  description: string;
  lengthOfInterview: number;
  name: string;
  researchType: ResearchType;
  svgIcon: string;
  content: ProjectAiInterviewContent;
}

export interface SaveAIProjectTemplateInput {
  description: string;
  category: number;
  name: string;
  targetCompletes: number;
  content: AIProjectTemplateContent;
}

export interface AIProjectTemplateQuestion {
  order: number;
  questionText: string;
  numberProbeQuestions: number;
  stimulusMediaId: string;
  stimulusName: string;
  mediaType: string;
  mediaSize: string;
}

export interface AIProjectTemplateContent {
  interviewerName: string;
  interviewTone: number;
  companyName: string;
  researchObjective: string;
  context: string;
  targetAudience: string;
  openingMessage: string;
  questions: AIProjectTemplateQuestion[];
}
